import Vue from 'vue'
import Router from 'vue-router'
import { lazyload } from '@/utils'
Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'historyList',
      component: lazyload('history_list'),
      meta:{
          title:'历史隐私政策'
      }
    },
    {
      path: '/cancellation',
      name: 'cancellation',
      component: lazyload('cancellation'),
      meta:{
            title:'注销账号'
        }
    },
    {
        path: '/cancellationResult',
        name: 'cancellationResult',
        component: lazyload('cancellation_result'),
        meta:{
            title:'注销'
        }
    },
    {
        path: '/useragreement',
        name: 'useragreement',
        component: lazyload('useragreement'),
        meta:{
            title:'用户协议'
        }
    },
    {
        path: '/policyDetail',
        name: 'policyDetail',
        component: lazyload('policy_detail'),
        meta:{
            title:'隐私政策'
        }
    },
  ]
})
